// VITE_API_BASE_URL is the host root (e.g. https://dev-app.rateyourstartup.vc).
// Function App's host.json sets routePrefix=api, so all HTTP endpoints live
// under /api/. We append it here so call sites can use bare paths.
// No fallback: missing env at build time must fail loud — we never want a prod
// bundle silently pointing at dev (or a same-origin path that 404s).
function requireEnv(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required build-time env var: ${name}`);
  return value;
}

// Local dev opt-in: VITE_API_RELATIVE=true makes the API base a relative `/api`
// so calls go to whatever origin serves the page (the Vite dev server, on
// whichever port it landed — 5173/5174/…), hitting the Vite proxy that forwards
// to the Functions host. Same-origin, so cookies work and there is no CORS. In
// this mode VITE_API_BASE_URL is not required.
const apiRelative = import.meta.env.VITE_API_RELATIVE === 'true';
const apiHostRoot = apiRelative
  ? ''
  : requireEnv('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL);
const publicAppBaseUrl = requireEnv('VITE_PUBLIC_APP_BASE_URL', import.meta.env.VITE_PUBLIC_APP_BASE_URL);

export const env = {
  api: {
    baseUrl: `${apiHostRoot}/api`,
  },
  publicAppBaseUrl,
  appInsights: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
  },
} as const;
